import { atom, useRecoilState } from 'recoil';
import type { RecoilState, SetterOrUpdater } from 'recoil';

export const hangingProtocolStudyDescriptions: RecoilState<string[]> = atom<string[]>({
  key: 'hangingProtocolStudyDescriptions',
  default: [],
});

export const useSelectedStudyDescriptions = (): [Array<string>, SetterOrUpdater<Array<string>>] => {
  return useRecoilState(hangingProtocolStudyDescriptions);
};
